import {
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TableBody,
  TextField,
  Typography,
} from "@material-ui/core";
import FormHelperText from "@material-ui/core/FormHelperText";
import Table from "@material-ui/core/Table";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import { useTheme } from "@material-ui/styles";
import AddRowButton from "components/common/AddRowButton";
import ContentTitle from "components/common/ContentTitle";
import Steper from "components/common/Steper";
import ButtonController from "components/request-document/components/ButtonController";
import {
  Bagde,
  StyledTableCell,
  TableRowHead,
  useStyles,
} from "components/request-document/components/Commons";
import CompanyInfoSection from "components/request-document/components/CompanyInfoSection";
import JobSection from "components/request-document/components/JobSection";
import usePersonalDetail from "components/request-document/hooks/usePersonalDetail";
import useSmartForm from "components/request-document/hooks/useSmartForm";
import useSmartService from "components/request-document/hooks/useSmartService";
import { useFormik } from "formik";
import { REQUEST_DOCUMENT_STEP } from "libs/configs/constant";
import { SMART_T_STEP } from "libs/constant/Step";
import useModalLoading from "libs/hooks/useModalLoading";
import {
  defaultJobTable,
  defaultShareholder,
  getDefaultRow,
  getErrorMessage,
  mapJobTable,
  mapShareholder,
} from "libs/utils/form";
import { get, isError } from "lodash-es";
import { React, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";
import { getMasterData, selectMasterData } from "redux/modules/masterSlice";
import { setSmartFormStep } from "redux/modules/uiSlice";
import {
  addSmartForm,
  addSmartFormSlice,
  getSmartFormFieldConfig,
  selectCurrentSmartForm,
  selectSmartFormFieldConfig,
} from "redux/modules/visaForm";
import * as yup from "yup";

export default function UserProfileStepD() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const theme = useTheme();

  const { showLoading, hideLoading } = useModalLoading();
  const [isSaveDraft, setSaveDraft] = useState(false);
  const canEdit = useSelector(canEditForm);
  const smartFormFieldConfig = useSelector(selectSmartFormFieldConfig);
  const smartform = useSelector(selectCurrentSmartForm);

  const { smartserviceId } = useSmartService();
  const { personalId } = usePersonalDetail();
  const { draftId, addSmartFormState, getSmartForm } = useSmartForm();

  const masterData = useSelector(selectMasterData);
  const nationalityConfig = get(masterData, "nationalityConfig", []);

  const smartNameById = (p, c) => ({ ...p, [c.smartName]: c });

  const detailList = [
    "CompanyName",
    "RegisterNumber",
    "Address",
    "OfficeNumber",
    "CompanyWebOrEmail",
    "JobTable",
    // "JobPosition",
    // "JobSubPosition",
    // "JobDescription",
    "Shareholder",
  ];
  const defaultType = get(smartFormFieldConfig, "data.defaultType", []);
  const partfromId =
    defaultType.find((field) => field.partFromName === "Part D")?.partfromId ||
    "";
  const detail = get(smartform, "detail", [])
    // .filter((field) => field.partfromId === partfromId)
    .filter((field) => detailList.includes(field.smartName))
    .reduce(smartNameById, {});

  useEffect(() => {
    dispatch(
      getMasterData({
        nationalityConfig: true,
        JobPositionConfig: true,
        CountryConfig: true,
      })
    );
  }, [dispatch]);

  useEffect(() => {
    if (smartserviceId) {
      dispatch(getSmartFormFieldConfig({ smartserviceId }));
      getSmartForm({
        smartserviceId,
        draftId,
        personalId,
      });
    }
  }, [dispatch, draftId, getSmartForm, personalId, smartserviceId]);

  useEffect(() => {
    if (!addSmartFormState.isLoading) {
      if (addSmartFormState.isSuccess) {
        hideLoading();
        dispatch(addSmartFormSlice.actions.clearAsyncState());
        if (!isSaveDraft) {
          dispatch(setSmartFormStep(SMART_T_STEP.PART_E));
        } else {
          getSmartForm({
            smartserviceId,
            draftId,
            personalId,
          });
        }
      } else if (addSmartFormState.isFailure) {
        hideLoading();
        alert(addSmartFormState.error?.message);
        dispatch(addSmartFormSlice.actions.clearAsyncState());
      }
    }
  }, [
    addSmartFormState.error?.message,
    addSmartFormState.isFailure,
    addSmartFormState.isLoading,
    addSmartFormState.isSuccess,
    dispatch,
    draftId,
    getSmartForm,
    hideLoading,
    isSaveDraft,
    personalId,
    smartserviceId,
  ]);

  const callAPISubmit = async (values) => {
    showLoading();
    const { visaissuance, ...restValues } = values;
    const documentFields = Object.keys(restValues);
    const getFieldListConfig = defaultType
      // .filter((field) => field.partfromId === partfromId)
      .filter((field) => documentFields.includes(field.smartName));

    const getValue = (field) => {
      switch (field.smartName) {
        case "Shareholder": {
          const shareholder = get(values, field.smartName, []);
          const value = shareholder.filter((v) => !!v.NameOfCompany);
          return value || null;
        }
        case "JobTable": {
          const jobTable = get(values, field.smartName, []);
          const value = jobTable.filter((v) => !!v.jobTitle);
          return value || null;
        }
        default:
          return get(values, `${field.smartName}`, null);
      }
    };

    const getSmartId = (field) =>
      get(detail, `${field.smartName}.smartId`, null);

    const prepareData = {
      draftId: draftId || null,
      smartserviceId,
      personalId: personalId,
      survey: null,
      visaissuance: visaissuance,
      detail: getFieldListConfig.map((field) => ({
        smartName: field.smartName,
        smartId: getSmartId(field),
        partfromId: field.partfromId,
        configsmartId: field.configsmartId,
        linkTable: field.linkTable,
        value: getValue(field),
      })),
    };

    await dispatch(
      addSmartForm({
        data: prepareData,
      })
    );
  };

  const validationSchema = yup.object({});
  const formik = useFormik({
    enableReinitialize: true,
    validationSchema,
    initialValues: {
      CompanyName: get(detail, "CompanyName.value", ""),
      RegisterNumber: get(detail, "RegisterNumber.value", ""),
      Address: get(detail, "Address.value", ""),
      OfficeNumber: get(detail, "OfficeNumber.value", ""),
      CompanyWebOrEmail: get(detail, "CompanyWebOrEmail.value", ""),
      JobTable: getDefaultRow(detail, "JobTable.value", defaultJobTable).map(
        mapJobTable
      ),
      // JobPosition: get(detail, "JobPosition.value", ""),
      // JobSubPosition: get(detail, "JobSubPosition.value", ""),
      // JobDescription: get(detail, "JobDescription.value", ""),
      Shareholder: getDefaultRow(
        detail,
        "Shareholder.value",
        defaultShareholder
      ).map(mapShareholder),
    },
    onSubmit: async (values) => {
      setSaveDraft(false);
      callAPISubmit(values);
    },
  });

  const mapFieldCompany = (fieldName) => {
    switch (fieldName) {
      case "CompanyAddress":
        return "Address";
      case "CompanyWebSite":
        return "CompanyWebOrEmail";
      case "CompanyRegisterNumber":
        return "RegisterNumber";
      default:
        return fieldName;
    }
  };

  const Shareholder = get(formik.values, "Shareholder", []);

  return (
    <div className={classes.root}>
      <form onSubmit={formik.handleSubmit}>
        <ContentTitle
          title="Application Form"
          subTitle="APPLICATION FOR QUALIFICATION ENDORSEMENT FOR SMART VISA “S”"
        />
        <Steper currentStep={1} stepInfo={REQUEST_DOCUMENT_STEP} />
        <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <StyledTableCell colSpan={4}>
                  <Typography variant="h6" className={classes.tableTitle}>
                    Part D : Company information
                  </Typography>
                </StyledTableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              <CompanyInfoSection
                colSpan={4}
                formik={formik}
                mapField={mapFieldCompany}
              />

              <TableRowHead>
                <StyledTableCell>
                  <div className={classes.cellContent}>
                    <Bagde number={6} />
                    <Typography variant="h6" className={classes.tableTitle}>
                      Name of company shareholders (in the order of major
                      shareholders)
                    </Typography>
                  </div>
                </StyledTableCell>
                <StyledTableCell>
                  <Typography
                    variant="h6"
                    className={classes.tableTitle}
                    style={{ width: 200 }}
                  >
                    Shares (%)
                  </Typography>
                </StyledTableCell>
                <StyledTableCell colSpan={2}>
                  <Typography variant="h6" className={classes.tableTitle}>
                    Nationality
                  </Typography>
                </StyledTableCell>
              </TableRowHead>

              {Shareholder.map((shareholder, index) => {
                if (!shareholder.Status) return null;
                const activeIndex = Shareholder.findIndex((v) => v.Status);
                return (
                  <TableRow key={index}>
                    <StyledTableCell>
                      <TextField
                        disabled={!canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name={`Shareholder.${index}.NameOfCompany`}
                        value={get(
                          formik.values,
                          `Shareholder.${index}.NameOfCompany`,
                          ""
                        )}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError(
                          `Shareholder.${index}.NameOfCompany`,
                          formik
                        )}
                        helperText={getErrorMessage(
                          `Shareholder.${index}.NameOfCompany`,
                          formik
                        )}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <TextField
                        disabled={!canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name={`Shareholder.${index}.SharesPercent`}
                        value={get(
                          formik.values,
                          `Shareholder.${index}.SharesPercent`,
                          ""
                        )}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError(
                          `Shareholder.${index}.SharesPercent`,
                          formik
                        )}
                        helperText={getErrorMessage(
                          `Shareholder.${index}.SharesPercent`,
                          formik
                        )}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <FormControl
                        variant="outlined"
                        className={classes.formControl}
                        style={{ width: 200 }}
                        error={isError(
                          `Shareholder.${index}.NationalityID`,
                          formik
                        )}
                      >
                        <InputLabel>Selected nationality</InputLabel>
                        <Select
                          disabled={!canEdit}
                          label="Selected nationality"
                          name={`Shareholder.${index}.NationalityID`}
                          value={get(
                            formik.values,
                            `Shareholder.${index}.NationalityID`,
                            ""
                          )}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        >
                          {nationalityConfig.map((nationality) => (
                            <MenuItem
                              value={nationality.nationalityID}
                              key={nationality.nationalityID}
                            >
                              {nationality.nationalityName}
                            </MenuItem>
                          ))}
                        </Select>
                        <FormHelperText
                          error={isError(
                            `Shareholder.${index}.NationalityID`,
                            formik
                          )}
                        >
                          {getErrorMessage(
                            `Shareholder.${index}.NationalityID`,
                            formik
                          )}
                        </FormHelperText>
                      </FormControl>
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <IconButton
                        disabled={!canEdit}
                        style={{ width: 40, color: theme.palette.error.main }}
                        size="small"
                        onClick={async () => {
                          if (
                            get(
                              formik.values,
                              `Shareholder[${index}].shareholderId`,
                              ""
                            )
                          ) {
                            formik.setFieldValue(
                              `Shareholder[${index}].Status`,
                              false
                            );
                          } else {
                            formik.setFieldValue(
                              "Shareholder",
                              Shareholder.filter((__, i) => i !== index)
                            );
                          }
                        }}
                      >
                        <DeleteForeverIcon />
                      </IconButton>
                      <FormHelperText error={false}> </FormHelperText>
                    </StyledTableCell>
                  </TableRow>
                );
              })}

              <TableRow>
                <StyledTableCell colSpan={4}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <AddRowButton
                      disabled={!canEdit}
                      onClick={() => {
                        formik.setFieldValue("Shareholder", [
                          ...Shareholder,
                          mapShareholder(defaultShareholder),
                        ]);
                      }}
                    />
                  </div>
                </StyledTableCell>
              </TableRow>

              <JobSection formik={formik} colSpan={4} bagdeStart={7} />
            </TableBody>
          </Table>
        </TableContainer>
        <ButtonController
          onClickSaveDraft={() => {
            if (!canEdit) {
              dispatch(setSmartFormStep(SMART_T_STEP.PART_E));
              return;
            }
            setSaveDraft(true);
            callAPISubmit(formik.values);
          }}
        />
      </form>
    </div>
  );
}
